import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dropdown, message, Space, Spin } from "@duxton-web/ui";
import { fetchMerchants, setSelectedMerchant } from './merchantSelectorSlice';
import { getSelectedMerchantIdFromLocalStorage, VIRTUAL_ENTITY } from "../../utils/merchantSelectorHelper";
import withProvider from "../../hoc/withProvider";
import { isVirtualEntitySystemEnabled } from "../../utils/featureFlagHelper";
export var MerchantSelector = function () {
    var _a;
    if (!isVirtualEntitySystemEnabled())
        return null;
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return state.merchantSelector; }), merchants = _b.merchants, loading = _b.loading, error = _b.error, selectedMerchant = _b.selectedMerchant;
    useEffect(function () {
        if (!merchants) {
            dispatch(fetchMerchants());
            return;
        }
        var storedMerchantId = getSelectedMerchantIdFromLocalStorage();
        var selectedMerchant = merchants === null || merchants === void 0 ? void 0 : merchants.find(function (merchant) { return merchant.id === storedMerchantId; });
        if (storedMerchantId && selectedMerchant) {
            dispatch(setSelectedMerchant(selectedMerchant));
        }
        else if ((merchants === null || merchants === void 0 ? void 0 : merchants.length) === 1) {
            dispatch(setSelectedMerchant(merchants[0]));
        }
        else {
            var normalMerchant = merchants === null || merchants === void 0 ? void 0 : merchants.find(function (merchant) { return merchant.type !== VIRTUAL_ENTITY; });
            normalMerchant ? dispatch(setSelectedMerchant(normalMerchant)) : dispatch(setSelectedMerchant(merchants[0]));
        }
    }, [dispatch, JSON.stringify(merchants)]);
    if (loading)
        return React.createElement(Spin, { "data-testid": "loading-spinner", size: "small" });
    if (error)
        return null;
    if (!merchants || merchants.length === 0)
        return null;
    if (merchants.length === 1)
        return null;
    var handleMenuClick = function (e) {
        var selectedMerchant = merchants.find(function (merchant) { return merchant.id === e.key; });
        if (selectedMerchant) {
            dispatch(setSelectedMerchant(selectedMerchant));
            message.info("Selected merchant: ".concat(selectedMerchant.display_name));
            setTimeout(function () { return window.location.href = "/portal"; }, 800);
        }
        else {
            message.error("merchant not found");
        }
    };
    var menuProps = {
        items: merchants.map(function (merchant) { return ({
            label: merchant.display_name,
            key: merchant.id,
        }); }),
        onClick: handleMenuClick,
    };
    return (React.createElement(Dropdown, { menu: menuProps },
        React.createElement(Button, { style: { marginLeft: "10px" } },
            React.createElement(Space, null, selectedMerchant ? "Selected Merchant: ".concat((_a = merchants.find(function (b) { return b.id === selectedMerchant.id; })) === null || _a === void 0 ? void 0 : _a.display_name) : 'Select merchant'))));
};
export default withProvider(MerchantSelector);
//# sourceMappingURL=merchantSelector.js.map